import { Popup } from 'components/Popup'
import { Typography } from 'components/Typography'
import { useBankAccountPopup } from './Providers/BankAccountPopupProvider'
import { BUTTON_TYPES, Button } from 'components/Button'
import { BTN_TXT } from 'constants/txt'
import { getDefaultReceivablePopupTitle } from './constants'

export const ThisAccountIsDefaultReceivableConfirmation = () => {
  const {
    thisAccountIsDefaultReceivableAccountPopup: { state, actions }
  } = useBankAccountPopup()

  const { name, callback, action } = state.payload

  return (
    <Popup
      {...state}
      title={getDefaultReceivablePopupTitle('thisAccountIsDefault', action)}
      zIndex={10000}
      width={442}
      onCancel={actions.close}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={actions.close} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button type={BUTTON_TYPES.PRIMARY} onClick={callback} upperCase>
            {BTN_TXT.CONTINUE}
          </Button>
        </>
      }
    >
      <Typography.Body1>
        {name} currently receives all payments and payouts for this community.{' '}
        {action === 'changePurpose'
          ? 'Changing its purpose will require choosing a new default.'
          : 'Deleting it will require choosing a new default.'}
      </Typography.Body1>
    </Popup>
  )
}
